<template>
    <div class="w-full h-full">
        <template v-if="pageType === 'back'">
            <van-nav-bar left-text="返回" left-arrow @click-left="back" />
        </template>
        <div class="w-full h-full group">
            <div class="w-full group-top">
                <div class="layout-side group-top-top">
                    <div class="group-top-top-item">
                        <div
                            class="w-full layout-center group-top-top-item-title"
                        >
                            注册用户
                        </div>
                        <div
                            class="w-full layout-center group-top-top-item-content"
                        >
                            <div
                                class="group-top-top-item-content-l"
                                style="color: #ff8000"
                            >
                                {{ groupInfo.registerNumber }}
                            </div>
                            <div class="group-top-top-item-content-r">人</div>
                        </div>
                    </div>
                    <div
                        class="group-top-top-item"
                        style="
                            border-left: var(--base-px-1) solid #d5d5d5;
                            border-right: var(--base-px-1) solid #d5d5d5;
                        "
                    >
                        <div
                            class="w-full layout-center group-top-top-item-title"
                        >
                            昨日新增
                        </div>
                        <div
                            class="w-full layout-center group-top-top-item-content"
                        >
                            <div
                                class="group-top-top-item-content-l"
                                style="color: #62d64b"
                            >
                                {{ groupInfo.yesterdayAddRegister }}
                            </div>
                            <div class="group-top-top-item-content-r">人</div>
                        </div>
                    </div>
                    <div class="group-top-top-item">
                        <div
                            class="w-full layout-center group-top-top-item-title"
                        >
                            今日新增
                        </div>
                        <div
                            class="w-full layout-center group-top-top-item-content"
                        >
                            <div
                                class="group-top-top-item-content-l"
                                style="color: #f4ab3c"
                            >
                                {{ groupInfo.dayAddRegister }}
                            </div>
                            <div class="group-top-top-item-content-r">人</div>
                        </div>
                    </div>
                </div>
                <div class="layout-center group-top-bottom">
                    <div class="group-top-bottom-item">
                        <div
                            class="w-full layout-center group-top-bottom-item-title"
                        >
                            今日会员奖励
                        </div>
                        <div
                            class="w-full layout-center group-top-bottom-item-content"
                        >
                            <div
                                class="group-top-bottom-item-content-l"
                                style="color: #fb4e4e"
                            >
                                {{ groupInfo.dayUserRedCount }}
                            </div>
                            <div class="group-top-bottom-item-content-r">
                                个
                            </div>
                        </div>
                    </div>
                    <div
                        class="group-top-bottom-item"
                        style="border-left: var(--base-px-1) solid #d5d5d5"
                    >
                        <div
                            class="w-full layout-center group-top-bottom-item-title"
                        >
                            今日会员奖励
                        </div>
                        <div
                            class="w-full layout-center group-top-bottom-item-content"
                        >
                            <div
                                class="group-top-bottom-item-content-l"
                                style="color: #5d83ff"
                            >
                                {{ groupInfo.dayUserRedMoney }}
                            </div>
                            <div class="group-top-bottom-item-content-r">
                                元
                            </div>
                        </div>
                    </div>
                    <div
                    v-if="is_open_points"
                        class="group-top-bottom-item"
                        style="border-left: var(--base-px-1) solid #d5d5d5"
                    >
                        <div
                            class="w-full layout-center group-top-bottom-item-title"
                        >
                            今日积分奖励
                        </div>
                        <div
                            class="w-full layout-center group-top-bottom-item-content"
                        >
                            <div
                                class="group-top-bottom-item-content-l"
                                style="color: #5d83ff"
                            >
                                {{ groupInfo.dayUserIntegrateTotal }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full group-center layout-side">
                <div
                    class="group-center-button layout-center"
                    @click="onActivated(0)"
                    :class="[
                        activeKey === 0 ? 'group-center-button-selected' : '',
                    ]"
                >
                    今日课程{{ activeKey === 0 ? `（${listCount}）` : "" }}
                </div>
                <div
                    class="group-center-button layout-center"
                    @click="onActivated(2)"
                    :class="[
                        activeKey === 2 ? 'group-center-button-selected' : '',
                    ]"
                >
                    直播计划{{ activeKey === 2 ? `（${listCount}）` : "" }}
                </div>
                <div
                    class="group-center-button layout-center"
                    @click="onActivated(1)"
                    :class="[
                        activeKey === 1 ? 'group-center-button-selected' : '',
                    ]"
                >
                    往日课程{{ activeKey === 1 ? `（${listCount}）` : "" }}
                </div>
            </div>
            <div class="w-full group-content">
                <div class="group-content-dis">
                    <div
                        style="
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        "
                    >
                        <div class="group-content-dis-t" @click="showPopup()">
                            营期选择 -
                            {{
                                selectTrain == null
                                    ? "全部"
                                    : selectTrain.train_name
                            }}
                        </div>
                        <div
                            v-if="is_live"
                            class="group-content-dis-t"
                            @click="onAuditOrder()"
                        >
                            审核订单
                        </div>
                    </div>
                    <div class="group-content-dis-f" v-show="activeKey === 2">
                        <div
                            class="group-content-dis-f-item"
                            :class="[
                                typeTime == 1
                                    ? 'group-content-dis-f-active'
                                    : '',
                            ]"
                            @click="updateTime(1)"
                        >
                            明日
                        </div>
                        <div
                            class="group-content-dis-f-item"
                            :class="[
                                typeTime == 2
                                    ? 'group-content-dis-f-active'
                                    : '',
                            ]"
                            @click="updateTime(2)"
                        >
                            后天
                        </div>
                        <div
                            class="group-content-dis-f-item"
                            :class="[
                                typeTime == 3
                                    ? 'group-content-dis-f-active'
                                    : '',
                            ]"
                            @click="updateTime(3)"
                        >
                            {{
                                formattedDate && typeTime == 3
                                    ? formattedDate
                                    : "自定义"
                            }}
                        </div>
                    </div>
                    <div class="group-content-dis-f" v-show="activeKey === 1">
                        <div
                            class="group-content-dis-f-item"
                            :class="[
                                typeTime == -1
                                    ? 'group-content-dis-f-active'
                                    : '',
                            ]"
                            @click="updateTime(-1)"
                        >
                            昨日
                        </div>
                        <div
                            class="group-content-dis-f-item"
                            :class="[
                                typeTime == -2
                                    ? 'group-content-dis-f-active'
                                    : '',
                            ]"
                            @click="updateTime(-2)"
                        >
                            前天
                        </div>
                        <div
                            class="group-content-dis-f-item"
                            :class="[
                                typeTime == 3
                                    ? 'group-content-dis-f-active'
                                    : '',
                            ]"
                            @click="updateTime(3)"
                        >
                            {{
                                formattedDate && typeTime == 3
                                    ? formattedDate
                                    : "自定义"
                            }}
                        </div>
                    </div>
                </div>
                <div
                    style="margin-bottom: var(--base-px-16)"
                    v-for="(campPeriod, index) in campPerlist"
                    :key="index"
                >
                    <div
                        class="w-full group-content-card"
                        v-if="campPeriod.lesson_title"
                    >
                        <div class="group-content-card-c layout-side">
                            <div class="group-content-card-c-l">
                                <img
                                    alt=""
                                    :src="campPeriod.video_image"
                                    class="w-full h-full"
                                />
                            </div>
                            <div class="group-content-card-c-r">
                                <div class="group-content-card-c-r-t">
                                    <div class="group-content-card-c-r-t-title">
                                        {{ campPeriod.lesson_title }}
                                    </div>
                                    <div
                                        v-show="activeKey != 2"
                                        class="group-content-card-c-r-t-number"
                                        @click.stop="onData(campPeriod)"
                                        style="white-space: nowrap"
                                    >
                                        数据统计>
                                    </div>
                                </div>
                                <div class="group-content-card-c-r-c">
                                    营期：{{ campPeriod.train_name }}
                                </div>
                                <div
                                    class="group-content-card-c-r-b layout-side"
                                >
                                    <div>时长：{{ campPeriod.times }}</div>
                                    <div
                                        v-if="
                                            activeKey != 1 &&
                                            !userDatalt.isDealer
                                        "
                                        class="layout-right-center"
                                        @click="onShare(campPeriod)"
                                        style="
                                            font-size: var(--base-px-12);
                                            color: #1a89f9;
                                        "
                                    >
                                        <img
                                            style="
                                                width: var(--base-px-10);
                                                height: var(--base-px-10);
                                                margin-right: var(--base-px-2);
                                            "
                                            src="../../assets/course/2.png"
                                        />分享
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="group-content-card-b layout-side">
                            <div style="width: 25%">
                                <div
                                    class="w-full layout-center b-t"
                                    style="
                                        height: var(--base-px-20);
                                        border-right: var(--base-px-1) solid
                                            #dbdbdb;
                                    "
                                >
                                    观看人数
                                </div>
                                <div
                                    class="w-full layout-center b-b"
                                    style="margin-top: var(--base-px-3)"
                                >
                                    {{ campPeriod.lessonWatchNumber }}
                                </div>
                            </div>
                            <div style="width: 25%">
                                <div
                                    class="w-full layout-center b-t"
                                    style="
                                        height: var(--base-px-20);
                                        border-right: var(--base-px-1) solid
                                            #dbdbdb;
                                    "
                                >
                                    完播率
                                </div>
                                <div
                                    class="w-full layout-center b-b"
                                    style="margin-top: var(--base-px-3)"
                                >
                                    {{ campPeriod.finishedRate }}
                                </div>
                            </div>
                            <div style="width: 25%">
                                <div
                                    class="w-full layout-center b-t"
                                    style="
                                        height: var(--base-px-20);
                                        border-right: var(--base-px-1) solid
                                            #dbdbdb;
                                    "
                                >
                                    答题人数
                                </div>
                                <div
                                    class="w-full layout-center b-b"
                                    style="margin-top: var(--base-px-3)"
                                >
                                    {{ campPeriod.watchNumber }}
                                </div>
                            </div>
                            <div style="width: 25%">
                                <div
                                    class="w-full layout-center b-t"
                                    style="height: var(--base-px-20)"
                                >
                                    正确率
                                </div>
                                <div class="w-full layout-center b-b">
                                    {{ campPeriod.correctRate }}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="w-full layout-center"
                    v-if="campPerlist.length == 0"
                >
                    <van-empty
                        class="custom-image"
                        :image="require('../../assets/images/emptyimg.png')"
                        description="暂无数据"
                    />
                </div>
            </div>
        </div>
        <div
            v-show="showShare"
            @click="onShareClose()"
            style="
                position: fixed;
                top: 0;
                left: 0;
                z-index: 98;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.7);
            "
        ></div>
        <div
            v-show="showShare"
            style="
                height: 20%;
                border-radius: var(--base-px-16) var(--base-px-16) 0px 0px;
                z-index: 2002;
                bottom: 0;
                left: 0;
                width: 100%;
                position: fixed;
                max-height: 100%;
                overflow-y: auto;
                background-color: #fff;
                transition: transform 0.3s, -webkit-transform 0.3s;
            "
        >
            <div
                class="w-full"
                style="
                    padding: var(--base-px-12);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                "
            >
                <div
                    style="
                        width: 25%;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                    "
                    v-for="(item, index) in options"
                    :key="'share_' + index"
                    :id="'share' + index"
                    :data-clipboard-text="item.link_data.url"
                    @click="
                        copy(
                            item.link_data.url,
                            'share' + index,
                            item.title,
                            item.video_image,
                            item.miniAppId,
                            item.pages
                        )
                    "
                >
                    <img
                        style="
                            width: var(--base-px-48);
                            height: var(--base-px-48);
                        "
                        :src="item.image"
                        alt=""
                    />
                    <div
                        class="layout-center"
                        style="
                            margin-top: var(--base-px-8);
                            color: #646566;
                            font-size: var(--base-px-12);
                        "
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <van-popup
            v-model="show"
            @clickOverlay="onDateCancel"
            position="bottom"
            class="group-p"
            :style="{ height: '60%' }"
        >
            <!-- <div class="">
				选择时间
			</div> -->
            <div class="group-p-t layout-center" style="position: relative">
                营期选择
            </div>
            <div class="group-p-c w-full">
                <div class="group-p-c-c w-full h-full">
                    <div
                        class="group-p-c-c-t w-full layout-left-center"
                        style="margin-bottom: var(--base-px-12)"
                    >
                        营期
                    </div>
                    <div class="group-p-c-c-c">
                        <div
                            class="group-p-c-c-c-l layout-side"
                            v-for="(item, index) in campPeriods"
                            :key="'cp_' + index"
                            :style="{
                                background:
                                    item.train_id === selectTrain?.train_id
                                        ? 'rgb(26, 137, 249)'
                                        : '',
                            }"
                            @click="onClickTrain(item)"
                        >
                            <!-- <div class="group-p-c-c-c-l-l layout-center"
								:style="{color: item.train_id===selectTrain?.train_id?'#ffffff':''}">{{ item.sort }}
							</div> -->
                            <div
                                class="group-p-c-c-c-l-r layout-left-center"
                                :style="{
                                    color:
                                        item.train_id === selectTrain?.train_id
                                            ? '#ffffff'
                                            : '',
                                }"
                            >
                                {{ item.train_name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full layout-side">
                    <div
                        class="layout-center"
                        @click="onCancel"
                        style="
                            width: 45%;
                            padding: var(--base-px-12) 0;
                            font-weight: 500;
                            font-size: var(--base-px-12);
                            color: #666666;
                            border-radius: var(--base-px-8) var(--base-px-8)
                                var(--base-px-8) var(--base-px-8);
                            border: var(--base-px-1) solid #cccccc;
                        "
                    >
                        取消
                    </div>
                    <div
                        class="layout-center"
                        @click="onOk"
                        style="
                            width: 45%;
                            padding: var(--base-px-12) 0;
                            background: #1a89f9;
                            font-weight: 500;
                            font-size: var(--base-px-12);
                            color: #ffffff;
                            border-radius: var(--base-px-8) var(--base-px-8)
                                var(--base-px-8) var(--base-px-8);
                        "
                    >
                        确认
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup
            v-model="showDate"
            position="bottom"
            class="group-d"
            :style="{ height: '53%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                class="h-full"
                title="营期选择"
                :min-date="minDate"
                :max-date="maxDate"
                :visible-item-count="10"
                @cancel="onDateCancel"
                @confirm="onDateConfirm"
            />
        </van-popup>
        <van-popup
            v-model="showCourseLinkAddType"
            position="center"
            round
            class="group-d"
            :style="{ height: '300px' }"
        >
            <div class="popup-content">
                <div class="popup-title">选择链接生成类型</div>
                <div class="radio-group">
                    <van-radio-group
                        v-model="course_link_add_type"
                        direction="vertical"
                    >
                        <van-radio name="1" class="radio-item"
                            >看课链接</van-radio
                        >
                        <van-radio name="2" class="radio-item"
                            >进粉链接</van-radio
                        >
                    </van-radio-group>
                </div>
                <div class="popup-footer">
                    <div class="btn cancel" @click="onCourseLinkAddTypeCancel">
                        取消
                    </div>
                    <div
                        class="btn confirm"
                        @click="onCourseLinkAddTypeConfirm"
                    >
                        确认
                    </div>
                </div>
            </div>
        </van-popup>
        <IndexModel
            v-if="data_model"
            :data="data_model"
            :train_lesson_id="train_lesson_id"
            v-on:close="data_model = false"
        >
        </IndexModel>
    </div>
</template>
<script>
import IndexModel from "./indexModel.vue";
import { trainLessonDataStatistics } from "@/api/course";
import { defineComponent, onActivated } from "vue";
import {
    groupManagerDetails,
    groupManagerTrainList,
    groupManagerTrainCourseList,
} from "@/api/my";
import { createCourseSharingLink } from "@/api/course";
import wechatIcon from "@/assets/course/3.png";
import miniIcon from "@/assets/course/4.png";
import shareIcon from "@/assets/share-k.png";
import Clipboard from "clipboard";
import { userCenter } from "@/api/homePage";
import {
    sendChatMessage,
    shareToExternalMoments,
} from "../../utils/wxCodeAuth";
import { message } from "ant-design-vue";

export default defineComponent({
    name: "group",
    components: {
        IndexModel,
    },
    data() {
        return {
            listCount: 0,
            pageType: "",
            campPerlist: [],
            campPeriod: {},
            campPeriods: [],
            activeKey: 0,
            show: false,
            showDate: false,
            groupInfo: {
                contactNumber: 0,
                dayAddContact: 0,
                dayAddRegister: 0,
                dayUserRedCount: 0,
                dayUserRedMoney: 0,
                registerNumber: 0,
                yesterdayAddRegister: 0,
            },
            minDate: new Date(2000, 0, 1),
            maxDate: new Date(2099, 10, 1),
            currentDate: new Date(),
            employeeId: "",
            formattedDate: "",
            selectTrain: null,
            userDatalt: {
                isDealer: false,
                name: "",
            },
            text: "http://www.baidu.com&" + Math.round(Math.random() * 10),
            showShare: false,
            options: [],
            typeTime: null,
            data_model: false,
            train_lesson_id: null,
            course_link_add_type: 1,
            showCourseLinkAddType: false,
            selectKcItem: null,
            is_live: process.env.VUE_APP_IS_LIVE === "false" ? false : true,
            is_open_points: process.env.VUE_APP_IS_OPEN_POINTS == '1' ? true : false,
        };
    },
    created() {
        const { id, type } = this.$route.query;
        console.log(type, id);
        this.pageType = type;
        this.employeeId = id;
        const item = JSON.parse(localStorage.getItem("userDetails"));
        if (item) {
            this.userDatalt = item;
        }
        groupManagerDetails({
            checkEmployeeId: this.employeeId,
        }).then((res) => {
            if (res.code == 1) {
                this.groupInfo = res.data;
            }
        });
        // groupManagerTrainCourseList({
        // 	employeeId: this.employeeId
        // }).then(res => {
        // 	this.campPeriod = res.data
        // })
        this.onActivated(0);
    },
    methods: {
        onAuditOrder() {
            this.$router.push({
                path: "/my/auditOrder",
                query: {
                    employeeId: this.employeeId,
                },
            });
        },
        getList() {
            groupManagerTrainCourseList({
                employeeId: this.employeeId,
                date: this.formattedDate,
                train_id: this.selectTrain?.train_id,
            }).then((res) => {
                if (res.code == 1) {
                    this.campPerlist = res.data; //后续直接赋值
                    this.listCount = res.data.length;
                }
            });
        },

        back() {
            this.$router.back();
        },
        copy(url, id, title, image, miniAppId, pages) {
            const that = this;
            this.text = url;
            let clipBoard = new Clipboard(`#${id}`);
            clipBoard.on("success", function () {
                clipBoard.destroy(); //销毁上一次的复制内容
                clipBoard = new Clipboard(`#${id}`);
                that.$toast.success("复制成功");
            });
            clipBoard.on("error", function () {
                that.$dialog.confirm({
                    title: "复制提示",
                    message: `链接生成失败，请重新点击获取`,
                    confirmButtonText: "我知道了",
                });
            });
        },
        onShareClose() {
            this.showShare = false;
        },
        async onShare(item) {
            this.showCourseLinkAddType = true;
            this.selectKcItem = item;
        },
        onActivated(e) {
            this.activeKey = e;
            // if (e === 1) {
            // 	this.showDate = true
            // 	this.formattedDate = this.gettiem(0);
            // 	this.currentDate=new Date(this.formattedDate);
            // } else {
            // 	// groupManagerTrainCourseList({
            // 	// 	employeeId: this.employeeId,
            // 	// 	train_id: this.selectTrain?.train_id
            // 	// }).then(res => {
            // 	// 	this.campPeriod = res.data

            // 	// })
            // }
            let d = 0;
            if (this.activeKey === 2) {
                d = 1;
            } else if (this.activeKey === 1) {
                d = -1;
            }
            this.updateTime(d);
        },
        showPopup() {
            this.campPeriods = [
                {
                    sort: "全部营期",
                    train_id: null,
                    train_name: "全部营期",
                },
            ];
            if (!this.selectTrain) {
                this.selectTrain = this.campPeriods[0];
            }
            groupManagerTrainList({
                employeeId: this.employeeId,
            }).then((res) => {
                let i = 1;
                res.data.forEach((item) => {
                    this.campPeriods.push({
                        ...item,
                        sort: `第${this.numberToChinese(i)}期`,
                    });
                    i++;
                });

                console.log(this.campPeriods);
                this.show = true;
            });
        },
        numberToChinese(num) {
            // 定义中文数字数组
            const chineseNumbers = [
                "零",
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
            ];

            // 处理0-10的情况
            if (num >= 0 && num <= 10) {
                return chineseNumbers[num] || "十"; // 10需要特殊处理
            }

            // 处理11-99的情况
            const tens = Math.floor(num / 10); // 十位数
            const units = num % 10; // 个位数

            let result = "";

            // 十位部分 (10-19特殊处理为"十x")
            if (tens === 1) {
                result = "十";
            } else {
                result = chineseNumbers[tens] + "十";
            }

            // 个位部分 (如果个位不为0则添加)
            if (units !== 0) {
                result += chineseNumbers[units];
            }

            return result;
        },
        onClickTrain(item) {
            if (item.train_id === this.selectTrain?.train_id) {
                this.selectTrain = null;
            } else {
                this.selectTrain = item;
            }
        },
        onCancel() {
            this.show = false;
        },
        onOk() {
            // groupManagerTrainCourseList({
            // 	employeeId: this.employeeId,
            // 	data: this.activeKey === 0 ? '' : this.formattedDate,
            // 	train_id: this.selectTrain?.train_id
            // }).then(res => {
            // 	this.campPeriod = res.data
            // 	this.show = false
            // })
            this.getList();
            this.show = false;
        },
        onDateCancel(e) {
            //this.activeKey = 0
            this.showDate = false;
        },
        onDateConfirm(e) {
            const date = this.currentDate;
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月份是从0开始的，所以要加1
            const day = date.getDate().toString().padStart(2, "0");
            this.formattedDate = `${year}-${month}-${day}`;
            this.showDate = false;
            // groupManagerTrainCourseList({
            // 	employeeId: this.employeeId,
            // 	date: this.formattedDate,
            // 	train_id: this.selectTrain?.train_id
            // }).then(res => {
            // 	this.campPeriod = res.data
            // })
            this.getList();
        },
        gettiem(offset) {
            const date = new Date();
            date.setDate(date.getDate() + offset);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");

            return `${year}-${month}-${day}`;
        },
        updateTime(type) {
            this.typeTime = type;
            if (this.typeTime === 3) {
                const date = new Date();
                if (this.activeKey == 1) {
                    //之前
                    date.setDate(date.getDate() - 1);
                    this.maxDate = date;
                    this.minDate = new Date(2000, 0, 1);
                } else if (this.activeKey == 2) {
                    //之后
                    date.setDate(date.getDate() + 1);
                    this.minDate = date;
                    this.maxDate = new Date(2099, 10, 1);
                }
                this.showDate = true;
            } else {
                this.formattedDate = this.gettiem(this.typeTime);
                this.currentDate = new Date(this.formattedDate);
                console.log(this.formattedDate);
                // groupManagerTrainCourseList({
                // 	employeeId: this.employeeId,
                // 	date: this.formattedDate,
                // 	train_id: this.selectTrain?.train_id
                // }).then(res => {
                // 	this.campPeriod = res.data
                // })
                this.getList();
            }
        },
        //数据统计
        onData: function (data = false) {
            trainLessonDataStatistics({
                train_lesson_id: data.train_lesson_id,
            }).then((r) => {
                this.train_lesson_id = data.train_lesson_id;
                this.data_model = r.data;
            });
        },
        onCourseLinkAddTypeCancel() {
            this.showCourseLinkAddType = false;
        },
        async onCourseLinkAddTypeConfirm() {
            this.showCourseLinkAddType = false;
            this.options = [];
            createCourseSharingLink({
                train_lesson_id: this.selectKcItem.train_lesson_id,
                validity_time: "100",
                course_link_add_type: this.course_link_add_type,
            }).then((one) => {
                if (one.data && Array.isArray(one.data)) {
                    console.log("这里");
                    let flag = false;
					let retry_message = ""
                    one.data.forEach((e) => {
                        console.log(e, e.type == "6" && e.retry_count > 0);
                        if (e.type == 6 && e.retry_count > 0) {
                            flag = true;
							retry_message = e.retry_count_message
                        }
                    });
                    console.log(flag);
                    if (flag) {
                        this.$dialog.confirm({
                            title: "提示",
                            message: retry_message||"链接生成失败，请重新点击获取",
                            confirmButtonText: "确认",
							showCancelButton:false
                        });
                        return;
                    }
                }
                this.options = one.data;
                this.options.forEach((e) => {
                    e.title = this.selectKcItem.lesson_title;
                    e.path_url = this.selectKcItem.path_url;
                    e.video_image = this.selectKcItem.video_image;
                });
                setTimeout(() => {
                    this.showShare = true;
                    this.showShare = false;
                    this.showShare = true;
                }, 100);
            });
        },
    },
});
</script>
<style lang="less">
.group {
    background: #f7f8fc;
    padding: var(--base-px-16) var(--base-px-12);

    .van-empty__image {
        height: auto;

        img {
            width: 100%;
            height: auto;
        }
    }

    &-top {
        height: var(--base-px-147);
        background: #ffffff;
        border-radius: var(--base-px-12) var(--base-px-12) var(--base-px-12)
            var(--base-px-12);
        padding: var(--base-px-16) 0;

        &-top {
            &-item {
                width: 33.33%;
                height: var(--base-px-49);

                &-title {
                    color: #333333;
                    font-size: var(--base-px-12);
                }

                &-content {
                    &-l {
                        font-weight: bold;
                        font-size: var(--base-px-20);
                    }

                    &-r {
                        color: #333333;
                        font-size: var(--base-px-12);
                        padding: var(--base-px-5) 0 0 var(--base-px-1);
                    }
                }
            }
        }

        &-bottom {
            margin-top: var(--base-px-25);
            height: var(--base-px-49);
            flex-wrap: nowrap;
            &-item {
                width: 50%;

                &-title {
                    color: #333333;
                    font-size: var(--base-px-12);
                }

                &-content {
                    &-l {
                        font-weight: bold;
                        font-size: var(--base-px-20);
                    }

                    &-r {
                        color: #333333;
                        font-size: var(--base-px-12);
                        padding: var(--base-px-5) 0 0 var(--base-px-1);
                    }
                }
            }
        }
    }

    &-center {
        height: var(--base-px-41);
        margin-top: var(--base-px-16);

        &-button {
            height: var(--base-px-41);
            border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8)
                var(--base-px-8);
            width: calc(35% - var(--base-px-16));
            font-weight: 500;
            font-size: var(--base-px-12);
            border: var(--base-px-1) solid #cccccc;
            color: #333333;

            &-selected {
                background: #1a89f9;
                color: #ffffff;
                border: var(--base-px-1) solid #1a89f9;
            }
        }
    }

    &-content {
        overflow: auto;
        margin-top: var(--base-px-23);

        &-dis {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: var(--base-px-19);

            &-t {
                font-family: Source Han Sans;
                color: #1a89f9;
                font-weight: 500;
                font-size: var(--base-px-16);
            }

            &-f {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                &-item {
                    font-family: Source Han Sans;
                    font-size: var(--base-px-14);
                    font-weight: 350;
                    color: #333333;
                    margin-right: var(--base-px-20);
                }

                &-active {
                    font-family: Source Han Sans;
                    font-size: var(--base-px-14);
                    font-weight: 350;
                    color: #1a89f9;
                    margin-right: var(--base-px-20);
                }
            }
        }

        &-card {
            background: #ffffff;
            border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8)
                var(--base-px-8);
            padding: var(--base-px-12);
            margin-bottom: var(--base-px-10);

            &-c {
                //margin-top: var(--base-px-12);

                &-l {
                    width: var(--base-px-100);
                    height: var(--base-px-57);
                    background: #f56464;
                    border-radius: var(--base-px-8) var(--base-px-8)
                        var(--base-px-8) var(--base-px-8);
                }

                &-r {
                    padding-left: var(--base-px-12);
                    width: calc(100% - var(--base-px-120));

                    &-t {
                        //height: var(--base-px-32);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        &-title {
                            font-weight: bold;
                            font-size: var(--base-px-14);
                            color: #333333;
                            //line-height: var(--base-px-16);
                            text-align: left;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            /* 限制两行 */
                            overflow: hidden;
                        }

                        &-number {
                            font-family: Source Han Sans;
                            font-size: var(--base-px-14);
                            font-weight: 350;
                            color: #1a89f9;
                        }
                    }

                    &-c {
                        margin-top: var(--base-px-11);
                        //height: var(--base-px-32);
                        font-weight: 500;
                        font-size: var(--base-px-11);
                        color: #333333;
                        //line-height: var(--base-px-16);
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        /* 限制两行 */
                        overflow: hidden;
                    }

                    &-b {
                        margin-top: var(--base-px-11);
                        //height: var(--base-px-17);
                        font-weight: 400;
                        font-size: var(--base-px-12);
                        color: #333333;
                        //line-height: var(--base-px-16);
                    }
                }
            }

            &-b {
                margin-top: var(--base-px-16);
                padding: 0 var(--base-px-14);

                .b-t {
                    font-weight: 500;
                    font-size: var(--base-px-14);
                    color: #333333;
                }

                .b-b {
                    font-weight: bold;
                    font-size: var(--base-px-14);
                    color: #333333;
                }
            }
        }
    }

    &-p {
        padding: 0 var(--base-px-13);

        &-t {
            padding: var(--base-px-14) 0 var(--base-px-12) 0;
            font-weight: bold;
            font-size: var(--base-px-14);
            color: #333333;
            border-bottom: var(--base-px-1) solid #ececec;

            &-l {
                position: absolute;
                left: 0;
                font-weight: 400;
                font-size: var(--base-px-13);
                color: #666666;
            }
        }

        &-c {
            padding-top: var(--base-px-12);
            height: calc(100% - var(--base-px-124));

            &-c {
                overflow: auto;
                padding-bottom: var(--base-px-4);

                &-t {
                    height: var(--base-px-20);
                    // font-weight: bold;
                    font-size: var(--base-px-14);
                    color: #333333;
                }

                &-c {
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    align-items: center;

                    &-l {
                        padding: var(--base-px-18) var(--base-px-25);
                        background: #f7f8fc;
                        border-radius: var(--base-px-8) var(--base-px-8)
                            var(--base-px-8) var(--base-px-8);
                        margin-bottom: var(--base-px-18);
                        margin-right: var(--base-px-28);

                        &-l {
                            font-weight: bold;
                            font-size: var(--base-px-12);
                            color: #333333;
                            height: var(--base-px-34);
                            width: var(--base-px-36);
                        }

                        &-r {
                            // padding-left: var(--base-px-24);
                            font-weight: 350;
                            font-size: var(--base-px-12);
                            color: #333333;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            /* 限制两行 */
                            overflow: hidden;
                        }
                    }
                }
            }
        }
    }
}

/* 弹窗样式 */
.popup-content {
    display: flex;
    flex-direction: column;
    width: 70vw;
    height: 100%;
    padding: var(--base-px-24);
    box-sizing: border-box;
    border-radius: 10px;

    .popup-title {
        font-size: var(--base-px-18);
        color: #333333;
        text-align: center;
        margin-bottom: var(--base-px-24);
        font-weight: 500;
    }

    .radio-group {
        flex: 1;
        padding: var(--base-px-0) var(--base-px-12);

        .radio-item {
            margin-bottom: var(--base-px-24);
            font-size: var(--base-px-16);
            color: #333333;
            display: flex;
            align-items: center;

            .van-radio__icon--checked {
                .van-icon {
                    color: #1a89f9;
                    border-color: #1a89f9;
                }
            }
        }
    }

    .popup-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: var(--base-px-24);

        .btn {
            width: 45%;
            height: var(--base-px-48);
            border-radius: var(--base-px-8);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: var(--base-px-16);
            cursor: pointer;
        }

        .cancel {
            background: #ffffff;
            color: #666666;
            border: var(--base-px-1) solid #cccccc;
        }

        .confirm {
            background: #1a89f9;
            color: #ffffff;
            border: var(--base-px-1) solid #1a89f9;
        }
    }
}
</style>
